import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import FormHeader from '@/components/v2/FormHeader.vue';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { EcommerceProductVariantInputModel } from '@/helpers/entities/interfaces/v2/model_implementations/EcommerceProductVariantInputModel';
let ProductVariancePermutationForm = class ProductVariancePermutationForm extends Mixins(ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.toggle = false;
        this.form = {
            ...this.formData,
        };
    }
    onCancel() {
        this.removeNewVariantPermutations();
        this.toggle = !this.toggle;
        this.formData.enableDependentStock = false;
    }
    removeNewVariantPermutations() {
        const variants = this.formData.productVariants.filter((variant) => variant.state !== 'idle');
        variants.forEach((variant) => {
            variant.state = 'deleted';
        });
    }
    filteredSections() {
        return this.formData.productSections.filter((sec) => sec.state !== 'deleted');
    }
    pushProductOptions(variant, event) {
        const { uuid, name, stockQuantity, limited, price, published, sectionName, compareAtPrice, } = event;
        const payload = {
            productOptionUuid: uuid,
            name,
            stockQuantity,
            limited,
            price,
            compareAtPrice,
            published,
            sectionName,
        };
        variant.productOptions.forEach((opt, i) => {
            if (opt.sectionName === sectionName) {
                variant.productOptions.splice(i, 1);
            }
        });
        variant.productOptions.push(payload);
    }
    disabledPublishToggle(variant) {
        const publishedVariants = this.formData.productVariants.filter((vars) => vars.published && vars.state !== 'deleted');
        if (publishedVariants.length <= 1 && variant.published) {
            return true;
        }
        return false;
    }
    addVariantPermutation() {
        const details = new EcommerceProductVariantInputModel();
        this.formData.productVariants.push(details);
    }
    onSubmit() {
        this.toggle = !this.toggle;
        this.$emit('submit', this.formData);
    }
};
__decorate([
    Prop({ type: Object, default: null })
], ProductVariancePermutationForm.prototype, "formData", void 0);
__decorate([
    Prop({ type: Object, default: null })
], ProductVariancePermutationForm.prototype, "permutations", void 0);
ProductVariancePermutationForm = __decorate([
    Component({
        components: {
            FormHeader,
            ActionButton,
        },
        validations: {
            formData: {},
        },
    })
], ProductVariancePermutationForm);
export default ProductVariancePermutationForm;
